// extracted by mini-css-extract-plugin
export default {"applicationsList":"Applications_applicationsList__aHj4d","applicationItem":"Applications_applicationItem__yzwca"};